module.exports = __webpack_public_path__ + "img/coupon_stamp-use.24f6ef52.png";